export const PLACEMENT_CATEGORIES = [
  'Auto',
  'Technology',
  'Beauty/Skincare',
  'Dating',
  'Pharma',
  'Alcohol',
  'Apparel',
  'Financial Services',
  'E-commerce',
  'Non-Alcoholic Beverages',
  'Protein Bars',
  'Other',
];

export const PLACEMENT_OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const PLACEMENTS_FILTER_OPTIONS = (selectedOptions = []) => {
  const selectedNames = selectedOptions.map(opt => opt.name);

  const options = PLACEMENT_CATEGORIES.filter(category => !selectedNames.includes(category))
    .map(category => ({
      _id: category,
      title: category,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));

  return [
    {
      _id: '__all__', // unique key
      title: 'Select All',
      disabled: true,
    },
    ...options,
  ];
};

export const SELECT_STYLES = {
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isDisabled ? null : isSelected ? 'grey' : isFocused ? 'grey' : null,
    color: isDisabled ? 'lightgrey' : isSelected ? 'white' : isFocused ? 'white' : 'black',
    cursor: 'default',
    '&:active': {
      backgroundColor: 'black',
      color: 'white',
    },
  }),
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? '#EBEBEB' : '#ccc',
    boxShadow: state.isFocused ? '0 0 0 1px #EBEBEB' : 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#EBEBEB' : '#999',
    },
    minHeight: '40px',
  }),
  multiValue: provided => ({ ...provided, margin: '5px' }),
  placeholder: () => ({
    fontSize: '12px',
    fontWeight: '100',
    color: 'grey',
  }),
  singleValue: style => ({
    ...style,
    backgroundColor: 'grey',
  }),
};

export const CARD_STYLES = {
  headerEdit: {
    background: '#90E2D3',
  },
  fontX: {
    fontSize: '12px',
  },
  fontLarge: {
    fontSize: '14px',
  },
  toast: {
    background: '#0F0F0F',
    text: '#FFFFFF',
  },
  error: {
    fontSize: '14px',
    color: 'red',
  },
};

/**
 * Handles product placement filter
 * @param {Object} filterModel - Current filter model
 * @param {Function} filterProjects - Bound method to update filters
 * @param {Function} recordEvent - Bound method for analytics
 * @returns {Promise} - Resolves after updating filters
 */

export const handlePlacementFilterWithExclusion = async (value, filterModel, { filterProjects, recordEvent }) => {
  // ensure placement shape exists
  if (!filterModel.placement) {
    filterModel.placement = {
      include: [],
      exclude: [],
    };
  }
  filterModel.placement.include = filterModel.placement.include || [];
  filterModel.placement.exclude = filterModel.placement.exclude || [];

  // CLEAR ALL (child sends null or '__clear__')
  if (value === null || value === '__clear__') {
    filterModel.placement.include = [];
    filterModel.placement.exclude = [];
    recordEvent &&
      recordEvent({
        data: 'placement.clear_all',
      });
    return filterProjects ? await filterProjects(filterModel) : filterModel;
  }

  // SELECT ALL (special id '__all__')
  if (value === '__all__') {
    if (Array.isArray(PLACEMENT_CATEGORIES)) {
      // Preserve excludes
      const excludes = filterModel.placement.exclude || [];

      // Everything else goes into include
      const includes = PLACEMENT_CATEGORIES.filter(cat => !excludes.includes(cat)).sort((a, b) => a.localeCompare(b));

      filterModel.placement.include = includes;
      filterModel.placement.exclude = excludes; // keep as-is
    }

    recordEvent &&
      recordEvent({
        data: 'placement.include_all',
      });
    return filterProjects ? await filterProjects(filterModel) : filterModel;
  }

  // NORMAL TOGGLE: if included -> remove, else -> add
  if (filterModel.placement.include.includes(value)) {
    filterModel.placement.include = filterModel.placement.include.filter(item => item !== value);
    recordEvent &&
      recordEvent({
        data: `placement.remove_${value}`,
      });
  } else {
    filterModel.placement.include.push(value);
    // ensure it's removed from exclude if present
    filterModel.placement.exclude = filterModel.placement.exclude.filter(item => item !== value);
    recordEvent &&
      recordEvent({
        data: `placement.include_${value}`,
      });
  }

  return filterProjects ? await filterProjects(filterModel) : filterModel;
};
